<template>
    <v-card width="auto" tile>
        <v-form ref="form">
            <v-card-text>
                <v-row dense class="mb-3">
                    <v-col cols="12" sm="6" md="6">
                        <v-text-field
                        v-model="model.nombres"
                        label="Nombres"
                        :rules="fieldRequired"
                        outlined
                        dense/>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                        <v-text-field
                        v-model="model.apellidos"
                        label="Apellidos"
                        :rules="fieldRequired"
                        outlined
                        dense/>
                    </v-col>
                    <v-col cols="10" sm="4" md="3">
                        <DatePicker :setterData="model.fecha_nacimiento" :itemAction="fields.fechaNacimiento" :on-success="actionFieldData"/>
                    </v-col>
                    <v-col cols="10" sm="3" md="3">
                      <v-select
                          v-model="model.estado_civil"
                          label="Estado Civil"
                          :items="estadoCivil"
                          :rules="fieldRequired"
                          outlined
                          dense>
                      </v-select>
                    </v-col>
                    <v-col cols="12" sm="5" md="6" class="refer">
                        <v-radio-group v-model="model.sexo" :rules="fieldRequired" row label="SEXO" class="radioButtons font-weight-bold">
                            <v-radio label="Femenino" value="F"></v-radio>
                            <v-radio label="Masculino" value="M"></v-radio>
                        </v-radio-group>
                    </v-col>
                </v-row>
                <v-card width="auto" outlined class="mb-3">
                  <v-card-title> Direccion </v-card-title>
                  <v-card-text>
                    <v-row dense>
                      <v-col cols="12" sm="3" md="2">
                          <v-text-field
                          v-model="model.datos.direccion.calle"
                          label="Calle"
                          :rules="fieldRequired"
                          outlined
                          dense/>
                      </v-col>
                      <v-col cols="6" sm="3" md="1">
                          <v-text-field
                          v-model="model.datos.direccion.numero"
                          label="Numero"
                          :rules="fieldRequired"
                          outlined
                          dense/>
                      </v-col>
                      <v-col cols="6" sm="3" md="2">
                          <v-text-field
                          v-model="model.datos.direccion.cruzamientos"
                          label="Cruzamientos"
                          :rules="fieldRequired"
                          outlined
                          dense/>
                      </v-col>
                      <v-col cols="6" sm="3" md="2">
                          <v-text-field
                          v-model="model.datos.direccion.codigo_postal"
                          label="CP"
                          :rules="fieldRequired"
                          outlined
                          dense/>
                      </v-col>
                      <v-col cols="12" sm="6" md="3">
                          <v-text-field
                          v-model="model.datos.direccion.colonia"
                          label="Colonia"
                          :rules="fieldRequired"
                          outlined
                          dense/>
                      </v-col>

                      <!-- Municipios -->
                      <v-col cols="12" sm="6" md="3">
                        <v-select
                          v-model="model.datos.direccion.municipio_id"
                          label="Municipio"
                          :items="municipios"
                          :rules="fieldRequired"
                          item-text="nombre"
                          item-value="id"
                          @change="selectedMunicipio"
                          clearable
                          outlined
                          dense>
                        </v-select>
                      </v-col>
                      <v-col cols="12" sm="6" md="3">
                        <v-select
                          v-model="model.datos.distrito.federal"
                          label="Distrito Federal"
                          :items="federales"
                          :rules="fieldRequired"
                          item-text="nombre"
                          item-value="id"
                          @change="selectedFederal"
                          outlined
                          dense>
                        </v-select>
                      </v-col>
                      <v-col cols="12" sm="6" md="3">
                        <v-select
                          v-model="model.datos.distrito.local"
                          label="Distrito Estatal"
                          :items="estatales"
                          :rules="fieldRequired"
                          item-text="nombre"
                          item-value="id"
                          @change="selectedEstatal"
                          outlined
                          dense>
                        </v-select>
                      </v-col>
                      <v-col cols="12" sm="6" md="3">
                        <v-select
                          v-model="model.seccion_id"
                          label="Secciones"
                          :items="secciones"
                          :rules="fieldRequired"
                          item-text="seccion"
                          item-value="id"
                          outlined
                          dense>
                        </v-select>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

                <v-card width="auto" outlined class="mb-3">
                  <v-card-title> Contacto </v-card-title>
                  <v-card-text>
                    <v-row dense>
                      <v-col cols="12" sm="4" md="4">
                          <v-text-field
                            v-model="model.datos.contacto.telefono"
                            label="Telefono"
                            :rules="fieldRequired"
                            outlined
                            dense />
                      </v-col>
                      <v-col cols="12" sm="4" md="4">
                        <v-text-field
                          v-model="model.datos.contacto.movil"
                          label="Movil"
                          :rules="fieldRequired"
                          outlined
                          dense/>
                      </v-col>
                      <v-col cols="12" sm="4" md="4">
                        <v-text-field
                          v-model="model.datos.contacto.correo"
                          label="Correo"
                          :rules="emailRules"
                          outlined
                          dense/>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

                <v-row dense class="mb-3">
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="model.curp"
                      label="CURP"
                      outlined
                      dense/>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="model.ife"
                      label="IFE"
                      outlined
                      dense/>
                  </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-layout justify-end>
                <v-btn class="red darken-1 mr-3" dark @click="onCancel">Cancelar</v-btn>
                <v-btn class="green darken-1 mr-3" dark @click="save"> Guardar</v-btn>
                </v-layout>
            </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { Validate } from '@/mixins/validateFormMixin'
import DatePicker from '@/components/fields/DatePicker'
export default {
  name: 'PermissionsFormCreate',
  mixins: [Validate],
  props: ['model', 'onSuccess', 'onCancel', 'edit'],
  data: () => ({
    fields: {
      fechaNacimiento: {
        name: 'Fecha de Nacimiento',
        nameid: 'fecha_nacimiento'
      }
    },
    estadoCivil: ['soltero', 'casado', 'divorciado', 'viudo'],
    municipios: [],
    federales: [],
    estatales: [],
    secciones: [],
    ids: [],
    seccionesIds: {
      federales: [],
      estatales: []
    }
  }),
  mounted () {
    this.getUrl('mun.get')
  },
  components: {
    DatePicker
  },
  methods: {
    selectedMunicipio (item) {
      this.ids = []
      if (item) {
        this.ids.push(item)
        this.getUrlDistritos('distr.bymun')
      }
    },
    selectedFederal (item) {
      this.seccionesIds.federales = []
      if (item) {
        this.seccionesIds.federales.push(item)
        if (this.seccionesIds.estatales.length > 0) {
          this.getUrlSecciones('secc.bydistritos')
        }
      }
    },
    selectedEstatal (item) {
      this.seccionesIds.estatales = []
      if (item) {
        this.seccionesIds.estatales.push(item)
        if (this.seccionesIds.federales.length > 0) {
          this.getUrlSecciones('secc.bydistritos')
        }
      }
    },
    ...mapActions(['getUrlServices', 'getUrlServicesAction', 'getUrlServiceThirdAction', 'postUrlServicesListActionSecound']),
    save () {
      // console.log('model', this.model)
      if (this.$refs.form.validate()) {
        this.onSuccess(this.model)
      } else {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'ERROR',
          text: 'Hay campos obligatorios'
        })
      }
    },
    getUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.getUrlServicesAction(router)
      } else {
        this.getUrlServices()
      }
    },
    getUrlDistritos (objet) {
      const router = this.get_urls[objet]
      // router.data = { ids: this.ids }
      this.getUrlServiceThirdAction({ url: router, data: { ids: this.ids } })
    },
    getUrlSecciones (objet) {
      const router = this.get_urls[objet]
      // router.data = this.seccionesIds
      this.postUrlServicesListActionSecound({ url: router, data: this.seccionesIds })
    },
    actionFieldData (obj) {
      this.model[obj.id] = (obj.data === undefined) ? null : obj.data
    }
  },
  computed: {
    ...mapGetters(['get_urls', 'get_objects', 'get_objectThird', 'get_objectsSecound'])
  },
  watch: {
    edit (val) {
      if (this.model.datos.direccion.municipio_id) {
        this.selectedMunicipio(this.model.datos.direccion.municipio_id)
      }
      if (this.model.datos.distrito.federal) {
        this.selectedFederal(this.model.datos.distrito.federal)
      }
      if (this.model.datos.distrito.local) {
        this.selectedEstatal(this.model.datos.distrito.local)
      }
    },
    get_urls () {
      this.getUrl('mun.get')
    },
    get_objects (vals) {
      if (vals) {
        this.municipios = vals
      }
    },
    get_objectThird (vals) {
      if (vals) {
        this.federales = vals.FEDERALES
        this.estatales = vals.ESTATALES
      }
    },
    get_objectsSecound (vals) {
      if (vals) {
        this.secciones = vals
      }
    }
  }

}
</script>

<style>
.refer{
  position: relative;
}
.radioButtons {
  margin: 0 auto;
  padding-top: 10px;
}
</style>
